import Axios from 'axios'

import { TPutResourceFilter } from 'types/GlobalDashboardFilter'
import {
  TCreateReportWidgetBody,
  TReport,
  TReportBlock,
  TResourceFilter,
  TUpdateReportBody
} from 'types/GlobalReport'
import { TReportWidget } from 'types/GlobalWidget'

import {
  getDefaultConfig,
  getWithRedirect,
  patchWithRedirect,
  postWithRedirect
} from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/reports`

export async function getAll() {
  return getWithRedirect<TReport[]>(URL)
}

export async function create(body: {
  title?: string
  folder_id?: string | null
}) {
  return postWithRedirect<TReport>(URL, { data: body })
}

export async function update(id: string, body: TUpdateReportBody) {
  return patchWithRedirect<TReport>(`${URL}/${id}`, { data: body })
}

export async function destroy(id: string) {
  return Axios.delete(`${URL}/${id}`, getDefaultConfig())
}

export async function reorderBlocks(
  reportId: string,
  body: Array<{ id: string; index: number }>
) {
  return patchWithRedirect(`${URL}/${reportId}/blocks/reorder`, { data: body })
}

export async function putFilters(reportId: string, data: TPutResourceFilter[]) {
  return Axios.put<{ data: TResourceFilter[] }>(
    `${URL}/${reportId}/report-filters`,
    { data },
    getDefaultConfig()
  )
}

export async function visit(id: string) {
  return Axios.put(`${URL}/${id}/visit`, {}, getDefaultConfig())
}

export async function copy(id: string) {
  return postWithRedirect<TReport>(`${URL}/${id}/copy`, { data: {} })
}

export async function createWidget(
  reportId: string,
  body: TCreateReportWidgetBody
) {
  return postWithRedirect<{
    block: TReportBlock
    widget: TReportWidget
  }>(`${URL}/${reportId}/widgets`, { data: body })
}
